import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../commonFunctions";
import { controls } from "../../controls";


const freezeinformation = {
  label: "Min Balance",
  pageLabel: "Min Balance",
  starting: true,
  url: "freezeinformation",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),

    ...controls.showData({ tab: "filter", data: "branch_display", width: "col-sm-2", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      tab: "freezeinformation",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product-1",
          value: "product-1"
        },
        {
          label: "product-2",
          value: "product-2"
        },
        {
          label: "product-3",
          value: "product-3"
        }
      ],
      placeHolder: "product",
      //   label: "Branch Code",
      name: "freezeinformationProduct",
      description: "Enter product"
    },
    {
      inputType: "showdata",
      tab: "freezeinformation",
      data: "freezeinformationProduct",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Acc. No. From",
      label: "Acc. No. From",
      name: "",
      description: "Acc. No. From"
    },
    {
      inputType: "numberonly",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "From",
      label: "",
      name: "freezeinformationAccNoFrom",
      description: "Enter Instruction No. From"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "To",
      name: "",
      description: "To"
    },
    {
      inputType: "numberonly",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "",
      name: "freezeinformationAccNoTo",
      description: "Enter To"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "From Date",
      label: "From Date",
      name: "",
      description: "From Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "From",
      label: "",
      name: "freezeinformationFromDate",
      description: "Enter From Date"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "To",
      name: "",
      description: "To"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "",
      name: "freezeinformationToDate",
      description: "Enter To"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Transaction Type",
      label: "Transaction Type",
      name: "",
      description: ""
    },
    {
      inputType: "autocomplete",
      tab: "freezeinformation",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "transaction type-1",
          value: "transaction type-1"
        },
        {
          label: "transaction type-2",
          value: "transaction type-2"
        },
        {
          label: "transaction type-3",
          value: "transaction type-3"
        }
      ],
      placeHolder: "product",
      //   label: "Branch Code",
      name: "freezeinformationTransactionType",
      description: "Enter product"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Amount From",
      label: "Amount From",
      name: "",
      description: "Amount From"
    },
    {
      inputType: "numberonly",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "From",
      label: "",
      name: "freezeinformationAmountFrom",
      description: "Enter Amount From"
    },
    {
      inputType: "displaytext",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "To",
      name: "",
      description: "To"
    },
    {
      inputType: "numberonly",
      tab: "freezeinformation",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "To",
      label: "",
      name: "freezeinformationAmountTo",
      description: "Enter To"
    }
  ]
}

export default freezeinformation;